import { v4 as uuidv4 } from 'uuid'

const DB_NAME = 'FileDatabase'
const DB_VERSION = 1
const STORE_NAME = 'files'

interface FileRecord {
  id: string
  file: File
}

export function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    if (!('indexedDB' in window)) {
      reject(new Error('IndexedDB를 지원하지 않는 브라우저입니다.'))
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onupgradeneeded = () => {
      const db = request.result
      db.createObjectStore(STORE_NAME, { keyPath: 'id' })
    }

    request.onsuccess = () => {
      resolve(request.result)
    }

    request.onerror = () => {
      reject(request.error)
    }
  })
}

export async function saveFile(file: File): Promise<string> {
  const db = await openDatabase()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readwrite')
    const store = transaction.objectStore(STORE_NAME)

    const id = uuidv4()
    const fileRecord: FileRecord = {
      id,
      file,
    }

    const request = store.add(fileRecord)

    request.onsuccess = () => {
      resolve(id)
    }

    request.onerror = () => {
      reject(request.error)
    }
  })
}

export async function clearAllFiles(): Promise<void> {
  const db = await openDatabase()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readwrite')
    const store = transaction.objectStore(STORE_NAME)

    const request = store.clear()

    request.onsuccess = () => {
      resolve()
    }

    request.onerror = () => {
      reject(request.error)
    }
  })
}

export async function getAllFiles(): Promise<FileRecord[]> {
  const db = await openDatabase()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readonly')
    const store = transaction.objectStore(STORE_NAME)

    const request = store.getAll()

    request.onsuccess = () => {
      resolve(request.result as FileRecord[])
    }

    request.onerror = () => {
      reject(request.error)
    }
  })
}
